import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles((theme) => ({
  show_price_container: {
    display: "flex",
    flexDirection: "column",
    lineHeight: "16px",
  },
  number: {
    fontSize: "25px",
    marginLeft: "4px",
  },
  currency: {
    color: theme.palette.grey[600],
    fontSize: "11px",
    marginLeft: "8px",
  },
  title: {
    fontSize: "12px",
    color: theme.palette.grey["600"],
    fontWeight: 800,
  },
  value: {
    fontSize: "18px",
    fontWeight: 600,
    marginTop: "3px",
  },
  articles_container: {
    marginTop: "8px",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  article_item_wrapper: {
    paddingBottom: "6px",
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    "&:last-child": {
      borderBottom: "none",
      paddingBottom: 0,
    },
  },
  article_item: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    lineHeight: "1.3",
  },
  article_name: {
    flex: 1,
    fontWeight: 500,
    color: theme.palette.grey[800],
  },
  article_badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    padding: "2px 8px",
    borderRadius: "4px",
    fontSize: "11px",
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  quantity_badge: {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
  },
  delivery_badge: {
    backgroundColor: theme.palette.grey[200],
    color: theme.palette.grey[700],
  },
}))

export { useStyles }
